export default __webpack_public_path__ + "static/media/section-icon.6f529408.svg";